module.exports = __webpack_public_path__ + "img/xitongyanfa.7112b547.png";